export const GET_ADMIN_LIST_REQUEST = 'GET_ADMIN_LIST_REQUEST'
export const GET_ADMIN_LIST_FAIL = 'GET_ADMIN_LIST_FAIL'
export const GET_ADMIN_LIST_SUCCESS = 'GET_ADMIN_LIST_SUCCESS'

export const ON_SEARCH_CHANGE_ADMIN = 'ON_SEARCH_CHANGE_ADMIN'
export const CLEAR_SEARCH_ADMIN = 'CLEAR_SEARCH_ADMIN'

export const ADMIN_LIST_SET_PAGINATION = 'ADMIN_LIST_SET_PAGINATION'
